module.exports = __webpack_public_path__ + "img/rs.7de031ff.svg";